import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { BooleanTag, Tag } from "@msuite/ui/tag";
import type { CostCenterListItem } from "@msuite/utils/types";
import { CostCentersRowActions } from "./cost-centers-row-actions";

const columnHelper = createColumnHelper<CostCenterListItem>();

export const columns = [
	columnHelper.accessor("number", {
		id: "number",
		header: localized("cost_centers.number"),
		cell: (cell) => (
			<Tag
				color={cell.row.original.color}
				variant="plain"
			>
				{cell.getValue()}
			</Tag>
		),
		size: 140,
	}),
	columnHelper.accessor("name", {
		id: "name",
		header: localized("cost_centers.name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("isActive", {
		id: "isActive",
		header: localized("cost_centers.is_active"),
		cell: (cell) => <BooleanTag value={cell.getValue()} />,
		size: 120,
	}),
	createRowActions(CostCentersRowActions),
];
